document.addEventListener('DOMContentLoaded', () => {
// slick default setting
let defaulsettings = {loop: true,speed: 700,effect: 'fade',fadeEffect: {crossFade: true},navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' },autoplay: {delay: 5000,disableOnInteraction: false}};

// start slider default
  let allSwipper =[];

document.querySelectorAll('.swiper-js').forEach((element,i) => {

  let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;

  element.setAttribute(`data-swiper-${i}`,"");

  let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

      allSwipper[i] = swiper;

      //custom count
      if(swiper.passedParams.customcount){
          let countcontainerall = document.querySelectorAll(`${swiper.passedParams.customcount}`);
          countcontainerall.forEach((element) => {element.innerHTML = `0${swiper.realIndex + 1}`});
          swiper.on('slideChange', () => {
              countcontainerall.forEach((element) =>{
                  element.innerHTML = `0${swiper.realIndex + 1}`;
              });
          });
      }

});

  //custom swiper controller
  allSwipper.forEach((swiper) => {
      const customControl = swiper.passedParams.customcontrol;
      if (customControl) {
          const targetIds = customControl.substr(1).split(" ");
          const targetSwipers = allSwipper.filter((s) => targetIds.includes(s.el.id));
          if (targetSwipers.length > 0) {
              swiper.controller.control = targetSwipers;
          }
      }
  });

  let swiperTop = document.querySelectorAll('.top-content');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            let swiperTopContent = new Swiper('.swiper-slides', {
                /*Optional parameters*/
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	

				allowTouchMove: false,
            });
        });
    };

	let swiperReviews = document.querySelectorAll('.reviews-block');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
            let swiperReviews = new Swiper('.swiper-reviews', {
                /*Optional parameters*/
                loop: true,
				effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				autoHeight: true,
				
                pagination: {
					el: ".reviews-pagination",
					clickable: true,
				},
            });
        });
    };

	let swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{
			let swiperGallery = new Swiper('.gallery-block__images', {
                /*Optional parameters*/
                loop: true,
				slidesPerView: 1,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				autoHeight: true,
				
                pagination: {
					el: ".gallery-block-pagination",
					clickable: true,
				},
            });
        });
    };

    let swiperGallery2 = document.querySelectorAll('.gallery-block-v2');
    if(swiperGallery2){
        swiperGallery2.forEach((item)=>{
			let swiperGallery2 = new Swiper('.gallery-block-v2__images', {
                /*Optional parameters*/
                loop: true,
				slidesPerView: 1,
                spaceBetween: 34,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				autoHeight: true,
				
                pagination: {
					el: ".gallery-block-v2-pagination",
					clickable: true,
				},

                breakpoints: {
					480: {
						slidesPerView: 2
					},
					1024: {
						slidesPerView: 3
					},
					1500: {
						slidesPerView: 4
					  }
				  }
            });
        });
    };

    
    let swiperCarousel = document.querySelectorAll('.carousel');
    if(swiperCarousel){


        let swiperPaginationReviews = new Swiper('.carousel-thumbnails', {
            loop: true,
            slidesPerView: 3,
    
            watchSlidesProgress: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            }
        });

        let swiperCarousel = new Swiper('.carousel-main', {
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            }, 
            thumbs: {
                swiper: swiperPaginationReviews,
            },
            pagination: {
                el: ".carousel-pagination",
                clickable: true
            }
        });       
    };
});